import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Vga = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g>
        <path d="M3.334 15.03A.333.333 0 0 1 3 14.698v-13H.667a.333.333 0 0 1 0-.666h2.667a.333.333 0 0 1 .333.334v13.332a.333.333 0 0 1-.333.334Z" />
        <path d="M15.333 11.364h-12a.333.333 0 1 1 0-.667H15V4.364H3.333a.333.333 0 1 1 0-.667h12a.333.333 0 0 1 .333.334v7a.333.333 0 0 1-.333.333ZM11 13.364H6.668a.333.333 0 1 1 0-.667h4.334a.334.334 0 0 1 0 .667ZM14.666 13.364h-1.667a.334.334 0 0 1 0-.667h1.667a.333.333 0 1 1 0 .667Z" />
      </g>
    </svg>
  );
};

Vga.category = 'product-category';

Vga.displayName = 'Vga';
